// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8E8C0","infos":"styles_infos__ZF-2c","info":"styles_info__uTiSH","title":"styles_title__hc-UE","value":"styles_value__KfTHU"};